import { Role } from './roles'

export interface UserProfileRoles {
  roles?: string[]
}

export const hasAdminRoles = (roles: Role[]): boolean =>
  roles.some(r =>
    [Role.ADMIN, Role.SUPER_ADMIN, Role.ACCOUNT_EXECUTIVE].includes(r)
  )

export const isAdminRole = (user: UserProfileRoles | undefined) =>
  hasAdminRoles((user?.roles ?? []) as Role[])
